import React from 'react';

const UploadIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
         stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
    >
        <path d="M12 3v12"/>
        <path d="m17 8-5-5-5 5"/>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    </svg>
);

export default UploadIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/UploadIcon.jsx